import { AxiosError } from 'axios';
import { userServices } from 'services';
import Terra from 'services/apis/terra/Terra';

const handleResponseError = (error: AxiosError) => {
  const status = error && error.response && error.response.status;
  switch (status) {
    case 401:
      // if (userServices.isLoggedIn()) {
      //   userServices.logout();
      // }
      break;
    case 403:
      if (shouldIgnoreCheck403Error(error.config.url)) {
        break;
      }

      userServices.denyAccess();
      break;
    default:
      // let message = null;
      // // Handle error message from API response
      // if (error.response && error.response.data) {
      //   const { data } = error.response;
      //   message = data.message;
      // }
      // notification.error({
      //   message: t('Error'),
      //   description: message || t('SomethingWentWrong'),
      // });
      break;
  }
};

const URL_ID_PART_PATTERN = '([\\d]+)';
const IGNORE_CHECK_403_URL_PATTERN_LIST = [
  new RegExp(
    `^${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/service-integrations/${URL_ID_PART_PATTERN}/configs/${URL_ID_PART_PATTERN}/init$`
  ),
  new RegExp(`/(.+)/service-integrations/(.+)/configs/sync$`),
];

function shouldIgnoreCheck403Error(url?: string): boolean {
  if (!url) return false;

  return IGNORE_CHECK_403_URL_PATTERN_LIST.some(urlPattern =>
    urlPattern.test(url)
  );
}

export default {
  handleResponseError,
};
